import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import TestimonialImg1 from '../../assets/images/testimonial/img1.png';
import TestimonialImg2 from '../../assets/images/testimonial/img2.png';
import TestimonialImg3 from '../../assets/images/testimonial/img3.png';
import TestimonialImg4 from '../../assets/images/testimonial/img4.png';

// Testimonial data
const testimonials = [
  {
    name: 'Ram',
    designation: 'Manager Elix Inc.',
    imgSrc: TestimonialImg1,
    quote: 'I would highly recommend TechTotalers team as they were very professional and helpful throughout the process of building our products. The incredible amount of effort and transparency with their requirements, Information Security and over all process was more detailed than we can imagine. Good luck with your future endeavors.',
    rating: 4,
  },
  {
    name: 'MR Harikesh Mishra',
    designation: 'CISO, JIL Infra Tech Ltd(Jaypee Group)',
    imgSrc: TestimonialImg2,
    quote: 'It was great working with TechTotalers team who extended their experience with focussed and committed team of Technical workforce. We had excellent work experience with them over our documentation requirements with state of art quality. We wish them good luck and bright future for their upcoming assignment.',
    rating: 5,
  },
  {
    name: 'Ritesh Mishra ',
    designation: "Global Head - IT & Security, Dr. Reddy's Laboratories Limited",
    imgSrc: TestimonialImg3,
    quote: 'The way TechTotalers has introduced solutions on cloud security is amazing. They have made the entire transition to the highly efficient, cost-effective Cloud Security Platform within no time. We wanted a partner on whom we could count on and TechTotalers has exceeded our expectations.',
    rating: 4,
  },
  // Add more testimonials as needed
];

// Swiper options
const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 2,
  spaceBetween: 30,
  speed: 2000,
  autoplay: {
    delay: 9000,
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next1',
    prevEl: '.swiper-button-prev1',
  },
  pagination: {
    el: '.swiper-dot-style1',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    0: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    375: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    575: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    768: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    992: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    1200: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    1320: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
  },
};

export default function TestimonialOne() {
  return (
    <>
      {/* Testimonial One Start */}
      <section className="testimonial-one">
        <div className="testimonial-one__wrap">
          <div className="testimonial-one__shape-1">
            <img src="assets/images/shapes/testimonial-one-shape-1.png" alt="" />
          </div>
          <div className="container">
            <div className="section-title text-left">
              <div className="section-title__tagline-box">
                <span className="section-title__tagline">Clients testimonial</span>
              </div>
              <h2 className="section-title__title"> Customer List<span> and Endorsement</span></h2>
            </div>

            {/* Swiper Slider */}
            <Swiper {...swiperOptions}>
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div className="testimonial-one__single">
                    <div className="testimonial-one__quote">
                      <span className="icon-quote"></span>
                    </div>
                    <div className="testimonial-one__client-info">
                      <div className="testimonial-one__client-img">
                        <img src={testimonial.imgSrc} alt={testimonial.name} />
                      </div>
                      <div className="testimonial-one__client-content">
                        <h3>
                          <Link to="/testimonials">{testimonial.name}</Link>
                        </h3>
                        <p>{testimonial.designation}</p>
                      </div>
                    </div>
                    <p className="testimonial-one__text">
                      {testimonial.quote}
                    </p>
                    <div className="testimonial-one__ratting">
                      {Array.from({ length: testimonial.rating }, (_, i) => (
                        <span key={i} className="icon-star"></span>
                      ))}
                      {Array.from({ length: 5 - testimonial.rating }, (_, i) => (
                        <span key={i} className="icon-star last-icon"></span>
                      ))}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
      {/* Testimonial One End */}
    </>
  );
}
